import { documentActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  selected: null,
  success: '',
  error: '',
};

const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SEARCH_SUCCESS: {
      const { documents } = action.payload;
      return {
        ...state,
        list: documents
      };
    }

    case actionType.GET_SUCCESS: {
      const { document } = action.payload;
      return {
        ...state,
        selected: { ...state.selected, ...document }
      };
    }

    case actionType.GET_FILE_SUCCESS: {
      const { document, blob, filename } = action.payload;
      const fileNameNoQuotes = filename.replace(/["]+/g, '');
      return {
        ...state,
        selected: {
          ...state.selected, ...document, blob, downloadName: fileNameNoQuotes
        }
      };
    }

    case actionType.DOWNLOAD_SUCCESS:
    case actionType.EMAIL_SUCCESS:
    case actionType.UPLOAD_SUCCESS: {
      const { successMessage } = action.payload;
      return {
        ...state,
        success: successMessage,
        error: ''
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { document } = action.payload;
      const newList = state.list.map((doc) => (doc.docId === document.docId ? document : doc));
      return {
        ...state,
        list: newList,
        selected: { ...state.selected, ...document }
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        success: '',
        error
      };
    }

    case actionType.CLEAR_LIST: {
      return {
        ...state,
        list: [],
        selected: null,
        success: '',
        error: ''
      };
    }

    case actionType.CLEAR_SELECTED: {
      return {
        ...state,
        selected: null,
        success: '',
        error: ''
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default documentReducer;
